// import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import { AutoFocus } from '@node_modules/primeng/autofocus';
import { Autoformat, ButtonView, Plugin } from 'ckeditor5';
import { visualDomDiff } from 'visual-dom-diff'
// import {ButtonView} from '@ckeditor/ckeditor5-ui/src/button/buttonview.js';


export default class AiSourceEditing extends Plugin {

    init() {
        const editor = this.editor;

        // Add a new button to the toolbar
        editor.ui.componentFactory.add('aisourceEditing', () => {
            const view = new ButtonView();
            view.set({
                label: 'AI content',
                icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.7756 5.77566L16.4308 3.81026H17.5692L18.2243 5.77566L20.1897 6.43079V7.56921L18.2243 8.22434L17.5692 10.1897H16.4308L15.7756 8.22434L13.8102 7.56921V6.43079L15.7756 5.77566Z" fill="black"/><path d="M18 12V19H16V12H18Z" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M7.33728 6H10.6627L14.0329 19H11.9668L11.1891 16H6.81082L6.03304 19H3.96692L7.33728 6ZM7.32934 14H10.6706L9.11505 8H8.88489L7.32934 14Z" fill="black"/></svg>',
                tooltip: true,
            });

            // Toggle source editing mode
            view.on('execute', () => {
                openSourceEditingModal(editor.getData(), newHtml => {
                    editor.setData(newHtml);
                });
            });
            return view;
        });

        // Optionally, you can add more enhancements here, e.g. validation, formatting, etc.
    }
}
// Hàm mở modal đơn giản (bạn nên thay bằng modal Angular/Bootstrap cho UX tốt hơn)
function openSourceEditingModal(currentHtml: string, onSave: (newHtml: string) => void) {
    debugger
    const opener = (window as any).openAiEditorModal;
    if (typeof opener === 'function') {
        opener(currentHtml, onSave);
        return;
    }
}

